import {
  Injectable,
  ApplicationRef,
  EnvironmentInjector,
  Injector,
  Type,
  EmbeddedViewRef,
  createComponent,
} from '@angular/core';

/**
 * Servicio de modales dinámicos propio del proyecto (reemplaza el de ng-uikit-pro-standard).
 * Usa la API moderna createComponent() (Angular 17+). Misma API: modalService.show(Componente, config).
 */

export class MDBModalRef {
  content: any = null;
  hide(): void {
    // Implementado por MDBModalService al crear el modal
  }
}

export interface MDBModalConfig {
  data?: { [key: string]: any };
  class?: string;
  backdrop?: boolean;
  ignoreBackdropClick?: boolean;
  animated?: boolean;
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class MDBSpinningPreloader {
  start(): void {}
  stop(): void {}
}

@Injectable({ providedIn: 'root' })
export class MDBModalService {
  /** Compatibilidad: algunos componentes acceden a modalService.config.data */
  config: MDBModalConfig = {};

  constructor(
    private appRef: ApplicationRef,
    private envInjector: EnvironmentInjector,
    private injector: Injector,
  ) {}

  show(component: Type<any>, config: MDBModalConfig = {}): MDBModalRef {
    this.config = config;
    const modalRef = new MDBModalRef();

    try {
      const childInjector = Injector.create({
        providers: [{ provide: MDBModalRef, useValue: modalRef }],
        parent: this.injector,
      });

      const compRef = createComponent(component, {
        environmentInjector: this.envInjector,
        elementInjector: childInjector,
      });

      if (config.data) {
        Object.assign(compRef.instance, config.data);
      }

      this.appRef.attachView(compRef.hostView);
      const domEl = (compRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

      const backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop fade show';
      backdrop.style.cssText = 'z-index:1040;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.5);';
      document.body.appendChild(backdrop);

      const modalEl = document.createElement('div');
      modalEl.className = 'modal fade show d-block';
      modalEl.style.cssText = 'z-index:1050;position:fixed;top:0;left:0;width:100%;height:100%;overflow-y:auto;';

      const dialogEl = document.createElement('div');
      dialogEl.className = 'modal-dialog ' + (config.class || '');
      dialogEl.style.marginTop = '5%';
      modalEl.appendChild(dialogEl);
      dialogEl.appendChild(domEl);
      document.body.appendChild(modalEl);
      document.body.classList.add('modal-open');

      const close = () => {
        this.appRef.detachView(compRef.hostView);
        compRef.destroy();
        if (modalEl.parentNode) { modalEl.parentNode.removeChild(modalEl); }
        if (backdrop.parentNode) { backdrop.parentNode.removeChild(backdrop); }
        document.body.classList.remove('modal-open');
      };

      if (!config.ignoreBackdropClick) {
        backdrop.addEventListener('click', () => close());
      }

      modalRef.hide = close;
    } catch (err) {
      console.warn('[MDBModalService] Could not mount component dynamically:', err);
    }

    return modalRef;
  }
}
